<template>
  <div class="jingLi">
    <statistics v-loading="sLoading" :list="statistics" :data="sData" />

    <div class="card-row">
      <chart-table2 source="gcDb" title="工程服务待办列表" class="row-col space-item" height="300" />
      <chart-table2 source="workYc" title="异常服务请求列表" class="row-col space-item" height="300" />
    </div>
  </div>
</template>

<script>
import Statistics from './components/statistics'
import ChartTable2 from './components/ChartTable2'
import request from '../../network/networkconfig';
/**
 * 项目经理 看板
 */
export default {
  name: 'viewGuanLi',
  components: { Statistics, ChartTable2 },
  data() {
    return {
      /** @type {import('./index.vue').IRoleId */
      roleId: 'jingLi',
      statistics: [
        { num: 0, field: 'ZSQ_WORK', tip: '总申请服务请求' },
        { num: 0, field: 'YWC_WORK', tip: '完成服务请求' },
        { num: 0, field: 'WWC_WORK', tip: '未完成服务请求' },
        { num: 0, field: 'WWC_SERVICE', tip: '未完成现场服务单' },
        { num: 0, field: 'YDD_SERVICE', tip: '已到达现场服务单' },
        // { num: 0, field: 'YC_WORK', tip: '异常服务请求' },
        { num: 0, field: 'YC_SERVICE', tip: '异常现场服务单' }
      ],
      sData: {},
      sLoading: false
    }
  },
  mounted: function() {
    this.getData()
  },
  methods: {
    getData: function() {
      let condition = {},
      roleId = this.roleId
      this.sLoading = true
      // this.api.queryList('YW_STATISTICS_JINGLI', { p2: condition, p9: '' }, `${roleId}_statistics`).then(
      //   res => {
      //     this.sLoading = false
      //     let resData = res.result
      //     this.sData = resData[0] || {}
      //   },
      //   err => {
      //     this.sLoading = true
      //   }
      // )
      request({
          url: process.env.API_HOST + '/yw/managerDataStatistics/'+ roleId + '_statistics',
          method: 'post',
      }).then(
        res => {
          this.sLoading = false
          let resData = res.result
          this.sData = resData[0] || {}
        },
        err => {
          this.sLoading = true
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/viewBoard/viewJingLi.vue